<p>students works!</p>
<div *ngFor="let student of students">
    <a routerLink="/management/student-edit/{{student.id}}">
        {{student.firstName}}
    </a>
</div>